import React from "react";

import ShipmentOrdersTable from "../ShipmentOrdersTable/ShipmentOrdersTable.jsx";

export const OrderShipmentsTable = ({ id, open }) => {
  return <ShipmentOrdersTable orderId={id} enabled={open} />;
};

export default OrderShipmentsTable;
